// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IBodyStyleType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class BodyStyleType implements IBodyStyleType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Ambulance BodyStyleType
	**/
    get AM(): IBodyStyleType {
        return this.FromId(1);
    }
    /**
		Returns Convertible BodyStyleType
	**/
    get CV(): IBodyStyleType {
        return this.FromId(2);
    }
    /**
		Returns Convertible 2 Dr BodyStyleType
	**/
    get TwoDCV(): IBodyStyleType {
        return this.FromId(3);
    }
    /**
		Returns Convertible 3 Dr BodyStyleType
	**/
    get ThreeDCV(): IBodyStyleType {
        return this.FromId(4);
    }
    /**
		Returns Convertible 4 Dr BodyStyleType
	**/
    get FourDCV(): IBodyStyleType {
        return this.FromId(5);
    }
    /**
		Returns Convertible 5 Dr BodyStyleType
	**/
    get FiveDCV(): IBodyStyleType {
        return this.FromId(6);
    }
    /**
		Returns Coupe BodyStyleType
	**/
    get CP(): IBodyStyleType {
        return this.FromId(7);
    }
    /**
		Returns Dune Buggy BodyStyleType
	**/
    get DBUG(): IBodyStyleType {
        return this.FromId(8);
    }
    /**
		Returns Hardtop BodyStyleType
	**/
    get HT(): IBodyStyleType {
        return this.FromId(9);
    }
    /**
		Returns Hardtop 2 Dr BodyStyleType
	**/
    get TwoDHT(): IBodyStyleType {
        return this.FromId(10);
    }
    /**
		Returns Hardtop 3 Dr BodyStyleType
	**/
    get ThreeDHT(): IBodyStyleType {
        return this.FromId(11);
    }
    /**
		Returns Hardtop 4 Dr BodyStyleType
	**/
    get FourDHT(): IBodyStyleType {
        return this.FromId(12);
    }
    /**
		Returns Hardtop 5 Dr BodyStyleType
	**/
    get FiveDHT(): IBodyStyleType {
        return this.FromId(13);
    }
    /**
		Returns Hatchback BodyStyleType
	**/
    get HB(): IBodyStyleType {
        return this.FromId(14);
    }
    /**
		Returns Hatchback 2 Dr BodyStyleType
	**/
    get TwoDHB(): IBodyStyleType {
        return this.FromId(15);
    }
    /**
		Returns Hatchback 3 Dr BodyStyleType
	**/
    get ThreeDHB(): IBodyStyleType {
        return this.FromId(16);
    }
    /**
		Returns Hatchback 4 Dr BodyStyleType
	**/
    get FourDHB(): IBodyStyleType {
        return this.FromId(17);
    }
    /**
		Returns Hatchback 5 Dr BodyStyleType
	**/
    get FiveDHB(): IBodyStyleType {
        return this.FromId(18);
    }
    /**
		Returns Hearse BodyStyleType
	**/
    get HR(): IBodyStyleType {
        return this.FromId(19);
    }
    /**
		Returns Jeep BodyStyleType
	**/
    get JP(): IBodyStyleType {
        return this.FromId(20);
    }
    /**
		Returns Liftback BodyStyleType
	**/
    get LB(): IBodyStyleType {
        return this.FromId(21);
    }
    /**
		Returns Liftback 2 Dr BodyStyleType
	**/
    get TwoDLB(): IBodyStyleType {
        return this.FromId(22);
    }
    /**
		Returns Liftback 3 Dr BodyStyleType
	**/
    get ThreeDLB(): IBodyStyleType {
        return this.FromId(23);
    }
    /**
		Returns Liftback 4 Dr BodyStyleType
	**/
    get FourDLB(): IBodyStyleType {
        return this.FromId(24);
    }
    /**
		Returns Liftback 5 Dr BodyStyleType
	**/
    get FiveDLB(): IBodyStyleType {
        return this.FromId(25);
    }
    /**
		Returns Limousine BodyStyleType
	**/
    get LM(): IBodyStyleType {
        return this.FromId(26);
    }
    /**
		Returns Motor Home A BodyStyleType
	**/
    get MHA(): IBodyStyleType {
        return this.FromId(27);
    }
    /**
		Returns Motor Home B BodyStyleType
	**/
    get MHB(): IBodyStyleType {
        return this.FromId(28);
    }
    /**
		Returns Motor Home C BodyStyleType
	**/
    get MHC(): IBodyStyleType {
        return this.FromId(29);
    }
    /**
		Returns Pickup BodyStyleType
	**/
    get PU(): IBodyStyleType {
        return this.FromId(30);
    }
    /**
		Returns Pickup 1/2 Ton BodyStyleType
	**/
    get TwelvePU(): IBodyStyleType {
        return this.FromId(31);
    }
    /**
		Returns Pickup 3/4 Ton BodyStyleType
	**/
    get ThirtyFourPU(): IBodyStyleType {
        return this.FromId(32);
    }
    /**
		Returns Recreational Vehicle BodyStyleType
	**/
    get RV(): IBodyStyleType {
        return this.FromId(33);
    }
    /**
		Returns Recreational Van BodyStyleType
	**/
    get RVVN(): IBodyStyleType {
        return this.FromId(34);
    }
    /**
		Returns Retractable Hardtop BodyStyleType
	**/
    get RH(): IBodyStyleType {
        return this.FromId(35);
    }
    /**
		Returns Retractable Hardtop 2 Dr BodyStyleType
	**/
    get TwoDRH(): IBodyStyleType {
        return this.FromId(36);
    }
    /**
		Returns Retractable Hardtop 3 Dr BodyStyleType
	**/
    get ThreeDRH(): IBodyStyleType {
        return this.FromId(37);
    }
    /**
		Returns Retractable Hardtop 4 Dr BodyStyleType
	**/
    get FourDRH(): IBodyStyleType {
        return this.FromId(38);
    }
    /**
		Returns Retractable Hardtop 5 Dr BodyStyleType
	**/
    get FiveDRH(): IBodyStyleType {
        return this.FromId(39);
    }
    /**
		Returns Roadster BodyStyleType
	**/
    get RD(): IBodyStyleType {
        return this.FromId(40);
    }
    /**
		Returns Sedan BodyStyleType
	**/
    get SD(): IBodyStyleType {
        return this.FromId(41);
    }
    /**
		Returns Sedan 2 Dr BodyStyleType
	**/
    get TwoDSD(): IBodyStyleType {
        return this.FromId(42);
    }
    /**
		Returns Sedan 3 Dr BodyStyleType
	**/
    get ThreeDSD(): IBodyStyleType {
        return this.FromId(43);
    }
    /**
		Returns Sedan 4 Dr BodyStyleType
	**/
    get FourDSD(): IBodyStyleType {
        return this.FromId(44);
    }
    /**
		Returns Sedan 5 Dr BodyStyleType
	**/
    get FiveDSD(): IBodyStyleType {
        return this.FromId(45);
    }
    /**
		Returns SP BodyStyleType
	**/
    get Special(): IBodyStyleType {
        return this.FromId(46);
    }
    /**
		Returns Station Wagon BodyStyleType
	**/
    get SW(): IBodyStyleType {
        return this.FromId(47);
    }
    /**
		Returns Station Wagon 2 Dr BodyStyleType
	**/
    get TwoDSW(): IBodyStyleType {
        return this.FromId(48);
    }
    /**
		Returns Station Wagon 3 Dr BodyStyleType
	**/
    get ThreeDSW(): IBodyStyleType {
        return this.FromId(49);
    }
    /**
		Returns Station Wagon 4 Dr BodyStyleType
	**/
    get FourDSW(): IBodyStyleType {
        return this.FromId(50);
    }
    /**
		Returns Station Wagon 5 Dr BodyStyleType
	**/
    get FiveDSW(): IBodyStyleType {
        return this.FromId(51);
    }
    /**
		Returns Van 1/2 Ton BodyStyleType
	**/
    get TwelveVN(): IBodyStyleType {
        return this.FromId(52);
    }
    /**
		Returns Van 3/4 Ton BodyStyleType
	**/
    get ThirtyFourVN(): IBodyStyleType {
        return this.FromId(53);
    }
    /**
		Returns Carryall BodyStyleType
	**/
    get LL(): IBodyStyleType {
        return this.FromId(54);
    }
    /**
		Returns Armored Truck BodyStyleType
	**/
    get AR(): IBodyStyleType {
        return this.FromId(55);
    }
    /**
		Returns Auto Carrier BodyStyleType
	**/
    get AC(): IBodyStyleType {
        return this.FromId(56);
    }
    /**
		Returns Beverage Rack BodyStyleType
	**/
    get BR(): IBodyStyleType {
        return this.FromId(57);
    }
    /**
		Returns Bus BodyStyleType
	**/
    get BS(): IBodyStyleType {
        return this.FromId(58);
    }
    /**
		Returns Cab & Chassis BodyStyleType
	**/
    get CB(): IBodyStyleType {
        return this.FromId(59);
    }
    /**
		Returns Concrete Mixer BodyStyleType
	**/
    get CM(): IBodyStyleType {
        return this.FromId(60);
    }
    /**
		Returns Crane BodyStyleType
	**/
    get CRA(): IBodyStyleType {
        return this.FromId(61);
    }
    /**
		Returns Drilling Truck BodyStyleType
	**/
    get DRTK(): IBodyStyleType {
        return this.FromId(62);
    }
    /**
		Returns Dump Truck BodyStyleType
	**/
    get DP(): IBodyStyleType {
        return this.FromId(63);
    }
    /**
		Returns Fire Truck BodyStyleType
	**/
    get FT(): IBodyStyleType {
        return this.FromId(64);
    }
    /**
		Returns Flatbed or Platform BodyStyleType
	**/
    get FB(): IBodyStyleType {
        return this.FromId(65);
    }
    /**
		Returns Garbage or Refuse BodyStyleType
	**/
    get GG(): IBodyStyleType {
        return this.FromId(66);
    }
    /**
		Returns Glass Rack BodyStyleType
	**/
    get GR(): IBodyStyleType {
        return this.FromId(67);
    }
    /**
		Returns Grain BodyStyleType
	**/
    get GN(): IBodyStyleType {
        return this.FromId(68);
    }
    /**
		Returns Hopper BodyStyleType
	**/
    get HO(): IBodyStyleType {
        return this.FromId(69);
    }
    /**
		Returns Lunch Wagon BodyStyleType
	**/
    get LW(): IBodyStyleType {
        return this.FromId(70);
    }
    /**
		Returns Open Seed Truck BodyStyleType
	**/
    get OS(): IBodyStyleType {
        return this.FromId(71);
    }
    /**
		Returns Panel BodyStyleType
	**/
    get PN(): IBodyStyleType {
        return this.FromId(72);
    }
    /**
		Returns Pickup 1 Ton BodyStyleType
	**/
    get OneTPU(): IBodyStyleType {
        return this.FromId(73);
    }
    /**
		Returns Refrigerated Van BodyStyleType
	**/
    get RF(): IBodyStyleType {
        return this.FromId(74);
    }
    /**
		Returns Road Tractor BodyStyleType
	**/
    get RT(): IBodyStyleType {
        return this.FromId(75);
    }
    /**
		Returns School Bus BodyStyleType
	**/
    get SCBS(): IBodyStyleType {
        return this.FromId(76);
    }
    /**
		Returns Service Body Truck BodyStyleType
	**/
    get SR(): IBodyStyleType {
        return this.FromId(77);
    }
    /**
		Returns Spreader Truck BodyStyleType
	**/
    get SPRT(): IBodyStyleType {
        return this.FromId(78);
    }
    /**
		Returns Stake or Rack BodyStyleType
	**/
    get ST(): IBodyStyleType {
        return this.FromId(79);
    }
    /**
		Returns Tank BodyStyleType
	**/
    get TN(): IBodyStyleType {
        return this.FromId(80);
    }
    /**
		Returns Trench Truck BodyStyleType
	**/
    get TRTK(): IBodyStyleType {
        return this.FromId(82);
    }
    /**
		Returns Truck BodyStyleType
	**/
    get TK(): IBodyStyleType {
        return this.FromId(83);
    }
    /**
		Returns Truck Tractor BodyStyleType
	**/
    get TT(): IBodyStyleType {
        return this.FromId(84);
    }
    /**
		Returns Van BodyStyleType
	**/
    get VN(): IBodyStyleType {
        return this.FromId(85);
    }
    /**
		Returns Van 1 Ton BodyStyleType
	**/
    get OneTVN(): IBodyStyleType {
        return this.FromId(86);
    }
    /**
		Returns Vannette BodyStyleType
	**/
    get VT(): IBodyStyleType {
        return this.FromId(87);
    }
    /**
		Returns Wrecker BodyStyleType
	**/
    get WR(): IBodyStyleType {
        return this.FromId(88);
    }
    /**
		Returns Wrencher BodyStyleType
	**/
    get WRTK(): IBodyStyleType {
        return this.FromId(89);
    }
    /**
		Returns Aqua Trailer BodyStyleType
	**/
    get AQTL(): IBodyStyleType {
        return this.FromId(90);
    }
    /**
		Returns Boat Trailer BodyStyleType
	**/
    get BT(): IBodyStyleType {
        return this.FromId(91);
    }
    /**
		Returns Box Trailer BodyStyleType
	**/
    get BX(): IBodyStyleType {
        return this.FromId(92);
    }
    /**
		Returns Cable Reel Trailer BodyStyleType
	**/
    get CL(): IBodyStyleType {
        return this.FromId(93);
    }
    /**
		Returns Concession Trailer BodyStyleType
	**/
    get CN(): IBodyStyleType {
        return this.FromId(94);
    }
    /**
		Returns Dolly Trailer BodyStyleType
	**/
    get DL(): IBodyStyleType {
        return this.FromId(95);
    }
    /**
		Returns Dump Trailer BodyStyleType
	**/
    get DPTL(): IBodyStyleType {
        return this.FromId(96);
    }
    /**
		Returns Flatbed Trailer BodyStyleType
	**/
    get FBTL(): IBodyStyleType {
        return this.FromId(97);
    }
    /**
		Returns Grain Trailer BodyStyleType
	**/
    get GNTL(): IBodyStyleType {
        return this.FromId(98);
    }
    /**
		Returns Hopper Trailer BodyStyleType
	**/
    get HOTL(): IBodyStyleType {
        return this.FromId(99);
    }
    /**
		Returns Horse Trailer BodyStyleType
	**/
    get HE(): IBodyStyleType {
        return this.FromId(100);
    }
    /**
		Returns Livestock Trailer BodyStyleType
	**/
    get LS(): IBodyStyleType {
        return this.FromId(101);
    }
    /**
		Returns Logging Trailer BodyStyleType
	**/
    get LP(): IBodyStyleType {
        return this.FromId(102);
    }
    /**
		Returns Lowbed/boy Trailer BodyStyleType
	**/
    get LBTL(): IBodyStyleType {
        return this.FromId(103);
    }
    /**
		Returns Luggage Trailer BodyStyleType
	**/
    get LG(): IBodyStyleType {
        return this.FromId(104);
    }
    /**
		Returns Motorcycle Trailer BodyStyleType
	**/
    get MCTL(): IBodyStyleType {
        return this.FromId(105);
    }
    /**
		Returns Pole Trailer BodyStyleType
	**/
    get PL(): IBodyStyleType {
        return this.FromId(106);
    }
    /**
		Returns Refrigerated Van Trailer BodyStyleType
	**/
    get RFTL(): IBodyStyleType {
        return this.FromId(107);
    }
    /**
		Returns Semi Trailer BodyStyleType
	**/
    get SE(): IBodyStyleType {
        return this.FromId(108);
    }
    /**
		Returns Service Trailer BodyStyleType
	**/
    get SRTL(): IBodyStyleType {
        return this.FromId(109);
    }
    /**
		Returns Snowmobile Carrier BodyStyleType
	**/
    get SNTL(): IBodyStyleType {
        return this.FromId(110);
    }
    /**
		Returns Stake Trailer BodyStyleType
	**/
    get STTL(): IBodyStyleType {
        return this.FromId(111);
    }
    /**
		Returns Tank Trailer BodyStyleType
	**/
    get TNTL(): IBodyStyleType {
        return this.FromId(112);
    }
    /**
		Returns Tent Trailer BodyStyleType
	**/
    get TE(): IBodyStyleType {
        return this.FromId(113);
    }
    /**
		Returns Trailer BodyStyleType
	**/
    get TL(): IBodyStyleType {
        return this.FromId(114);
    }
    /**
		Returns Travel Trailer BodyStyleType
	**/
    get TV(): IBodyStyleType {
        return this.FromId(115);
    }
    /**
		Returns Utility Trailer BodyStyleType
	**/
    get UT(): IBodyStyleType {
        return this.FromId(116);
    }
    /**
		Returns Van Trailer BodyStyleType
	**/
    get VNTL(): IBodyStyleType {
        return this.FromId(117);
    }
    /**
		Returns All Terrain Cycle BodyStyleType
	**/
    get ATC(): IBodyStyleType {
        return this.FromId(118);
    }
    /**
		Returns All Terrain Vehicle BodyStyleType
	**/
    get ATV(): IBodyStyleType {
        return this.FromId(119);
    }
    /**
		Returns Golf Cart BodyStyleType
	**/
    get GC(): IBodyStyleType {
        return this.FromId(120);
    }
    /**
		Returns Motorcycle with Unique Modifications BodyStyleType
	**/
    get MCSP(): IBodyStyleType {
        return this.FromId(121);
    }
    /**
		Returns Moped BodyStyleType
	**/
    get MP(): IBodyStyleType {
        return this.FromId(122);
    }
    /**
		Returns Motorcycle BodyStyleType
	**/
    get MC(): IBodyStyleType {
        return this.FromId(123);
    }
    /**
		Returns Neighborhood Electric Vehicle BodyStyleType
	**/
    get NEV(): IBodyStyleType {
        return this.FromId(124);
    }
    /**
		Returns Wheel Chair/Motorcycle Vehicle BodyStyleType
	**/
    get WCMC(): IBodyStyleType {
        return this.FromId(125);
    }
    /**
		Returns Modular Building BodyStyleType
	**/
    get MB(): IBodyStyleType {
        return this.FromId(126);
    }
    /**
		Returns Mobile Home BodyStyleType
	**/
    get MH(): IBodyStyleType {
        return this.FromId(127);
    }
    /**
		Returns Office Trailer BodyStyleType
	**/
    get OT(): IBodyStyleType {
        return this.FromId(128);
    }
    /**
		Returns Park Model Trailer BodyStyleType
	**/
    get PT(): IBodyStyleType {
        return this.FromId(129);
    }
    /**
		Returns Competition BodyStyleType
	**/
    get CO(): IBodyStyleType {
        return this.FromId(300);
    }
    /**
		Returns Cruiser BodyStyleType
	**/
    get CR(): IBodyStyleType {
        return this.FromId(301);
    }
    /**
		Returns Dirt Bike BodyStyleType
	**/
    get DT(): IBodyStyleType {
        return this.FromId(302);
    }
    /**
		Returns Enduro BodyStyleType
	**/
    get EN(): IBodyStyleType {
        return this.FromId(303);
    }
    /**
		Returns MINI BIKE BodyStyleType
	**/
    get MN(): IBodyStyleType {
        return this.FromId(304);
    }
    /**
		Returns Scooter BodyStyleType
	**/
    get MS(): IBodyStyleType {
        return this.FromId(305);
    }
    /**
		Returns Sport BodyStyleType
	**/
    get SP(): IBodyStyleType {
        return this.FromId(306);
    }
    /**
		Returns Touring BodyStyleType
	**/
    get TO(): IBodyStyleType {
        return this.FromId(307);
    }
    /**
		Returns Traditional BodyStyleType
	**/
    get TR(): IBodyStyleType {
        return this.FromId(308);
    }
    /**
		Returns UNKNOWN BodyStyleType
	**/
    get UNK(): IBodyStyleType {
        return this.FromId(310);
    }
    /**
		Returns Roll Off BodyStyleType
	**/
    get ROL(): IBodyStyleType {
        return this.FromId(311);
    }
    /**
		Returns Special BodyStyleType
	**/
    get SPE(): IBodyStyleType {
        return this.FromId(312);
    }
    /**
		Returns Transfer BodyStyleType
	**/
    get TRN(): IBodyStyleType {
        return this.FromId(313);
    }
    /**
		Returns Curtainside BodyStyleType
	**/
    get CUR(): IBodyStyleType {
        return this.FromId(314);
    }
    /**
		Returns Station Wagon 6 Dr BodyStyleType
	**/
    get SixDSW(): IBodyStyleType {
        return this.FromId(315);
    }
    /**
		Returns Coupe 2 Dr BodyStyleType
	**/
    get TwoDCP(): IBodyStyleType {
        return this.FromId(316);
    }
    /**
		Returns Coupe 3 Dr BodyStyleType
	**/
    get ThreeDCP(): IBodyStyleType {
        return this.FromId(318);
    }
    /**
		Returns Coupe 4 Dr BodyStyleType
	**/
    get FourDCP(): IBodyStyleType {
        return this.FromId(319);
    }
    /**
		Returns Cab & Chassis 2 Dr BodyStyleType
	**/
    get TwoCB(): IBodyStyleType {
        return this.FromId(320);
    }
    /**
		Returns Cab & Chassis 3 Dr BodyStyleType
	**/
    get ThreeCB(): IBodyStyleType {
        return this.FromId(321);
    }
    /**
		Returns Cab & Chassis 4 Dr BodyStyleType
	**/
    get FourCB(): IBodyStyleType {
        return this.FromId(322);
    }
    /**
		Returns Cutaway BodyStyleType
	**/
    get YY(): IBodyStyleType {
        return this.FromId(323);
    }
    /**
		Returns Cutaway 2 Dr BodyStyleType
	**/
    get TwoYY(): IBodyStyleType {
        return this.FromId(324);
    }
    /**
		Returns Cutaway 3 Dr BodyStyleType
	**/
    get ThreeYY(): IBodyStyleType {
        return this.FromId(325);
    }
    /**
		Returns Gliders BodyStyleType
	**/
    get GL(): IBodyStyleType {
        return this.FromId(326);
    }
    /**
		Returns Incomplete (Strip Chassis) BodyStyleType
	**/
    get IC(): IBodyStyleType {
        return this.FromId(327);
    }
    /**
		Returns Incomplete (Strip Chassis) 2 Dr BodyStyleType
	**/
    get TwoIC(): IBodyStyleType {
        return this.FromId(328);
    }
    /**
		Returns Incomplete (Strip Chassis) 3 Dr BodyStyleType
	**/
    get ThreeIC(): IBodyStyleType {
        return this.FromId(329);
    }
    /**
		Returns Incomplete Pickup BodyStyleType
	**/
    get IP(): IBodyStyleType {
        return this.FromId(330);
    }
    /**
		Returns Incomplete Pickup 2 Dr BodyStyleType
	**/
    get TwoIP(): IBodyStyleType {
        return this.FromId(331);
    }
    /**
		Returns Incomplete Pickup 3Dr BodyStyleType
	**/
    get ThreeIP(): IBodyStyleType {
        return this.FromId(332);
    }
    /**
		Returns Incomplete Pickup 4Dr BodyStyleType
	**/
    get FourIP(): IBodyStyleType {
        return this.FromId(333);
    }
    /**
		Returns Pickup 2Dr BodyStyleType
	**/
    get TwoPU(): IBodyStyleType {
        return this.FromId(335);
    }
    /**
		Returns Pickup 3 Dr BodyStyleType
	**/
    get ThreePU(): IBodyStyleType {
        return this.FromId(336);
    }
    /**
		Returns Pickup 4 Dr BodyStyleType
	**/
    get FourPU(): IBodyStyleType {
        return this.FromId(337);
    }
    /**
		Returns Passenger Van 2 Dr BodyStyleType
	**/
    get TwoDPV(): IBodyStyleType {
        return this.FromId(350);
    }
    /**
		Returns Passenger Van 3 Dr BodyStyleType
	**/
    get ThreeDPV(): IBodyStyleType {
        return this.FromId(351);
    }
    /**
		Returns Passenger Van 4 Dr BodyStyleType
	**/
    get FourDPV(): IBodyStyleType {
        return this.FromId(352);
    }
    /**
		Returns Passenger Van 5 Dr BodyStyleType
	**/
    get FiveDPV(): IBodyStyleType {
        return this.FromId(353);
    }
    /**
		Returns Cargo Van BodyStyleType
	**/
    get CG(): IBodyStyleType {
        return this.FromId(354);
    }
    /**
		Returns Cargo Van 2 Dr BodyStyleType
	**/
    get TwoDCG(): IBodyStyleType {
        return this.FromId(355);
    }
    /**
		Returns Cargo Van 3 Dr BodyStyleType
	**/
    get ThreeDCG(): IBodyStyleType {
        return this.FromId(356);
    }
    /**
		Returns Cargo Van 4 Dr BodyStyleType
	**/
    get FourDCG(): IBodyStyleType {
        return this.FromId(357);
    }
    /**
		Returns Cargo Van 5 Dr BodyStyleType
	**/
    get FiveDCG(): IBodyStyleType {
        return this.FromId(358);
    }
    /**
		Returns Motor Home B 3 Dr BodyStyleType
	**/
    get ThreeDMHB(): IBodyStyleType {
        return this.FromId(360);
    }
    /**
		Returns Straight Truck BodyStyleType
	**/
    get STT(): IBodyStyleType {
        return this.FromId(361);
    }
    /**
		Returns Straight Truck 2 Dr BodyStyleType
	**/
    get TwoDSTT(): IBodyStyleType {
        return this.FromId(362);
    }
    /**
		Returns Straight Truck 4 Dr BodyStyleType
	**/
    get FourDSTT(): IBodyStyleType {
        return this.FromId(363);
    }
    /**
		Returns Step Van BodyStyleType
	**/
    get SV(): IBodyStyleType {
        return this.FromId(364);
    }
    /**
		Returns Step Van 2 Dr BodyStyleType
	**/
    get TwoDSV(): IBodyStyleType {
        return this.FromId(365);
    }
    /**
		Returns Step Van 3 Dr BodyStyleType
	**/
    get ThreeDSV(): IBodyStyleType {
        return this.FromId(366);
    }
    /**
		Returns Motor Home B 2 Dr BodyStyleType
	**/
    get TwoDMHB(): IBodyStyleType {
        return this.FromId(380);
    }
    /**
		Returns Camper Van 3 Dr BodyStyleType
	**/
    get ThreeDVC(): IBodyStyleType {
        return this.FromId(382);
    }
    /**
		Returns Passenger Van BodyStyleType
	**/
    get PV(): IBodyStyleType {
        return this.FromId(390);
    }
    /**
		Returns Camper Van BodyStyleType
	**/
    get VC(): IBodyStyleType {
        return this.FromId(391);
    }
    /**
		Returns Limousine 4 Dr BodyStyleType
	**/
    get FourDLM(): IBodyStyleType {
        return this.FromId(392);
    }
    /**
		Returns Hearse 4 Dr BodyStyleType
	**/
    get FourDHR(): IBodyStyleType {
        return this.FromId(393);
    }
    /**
		Returns Commercial Chassis 4 Dr BodyStyleType
	**/
    get FourCC(): IBodyStyleType {
        return this.FromId(394);
    }
    /**
		Returns Contain Chassis BodyStyleType
	**/
    get CCH(): IBodyStyleType {
        return this.FromId(395);
    }
    /**
		Returns Neighborhood Electric Shuttle BodyStyleType
	**/
    get NES(): IBodyStyleType {
        return this.FromId(396);
    }
    /**
		Returns Motorized Quadricycle BodyStyleType
	**/
    get MQ(): IBodyStyleType {
        return this.FromId(397);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'AM', displayValue: 'Ambulance', description: 'Ambulance', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'CV', displayValue: 'Convertible', description: 'Convertible', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: '2DCV', displayValue: 'Convertible 2 Dr', description: 'Convertible 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: '3DCV', displayValue: 'Convertible 3 Dr', description: 'Convertible 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: '4DCV', displayValue: 'Convertible 4 Dr', description: 'Convertible 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: '5DCV', displayValue: 'Convertible 5 Dr', description: 'Convertible 5 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'CP', displayValue: 'Coupe', description: 'Coupe', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'DBUG', displayValue: 'Dune Buggy', description: 'Dune Buggy', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'HT', displayValue: 'Hardtop', description: 'Hardtop', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: '2DHT', displayValue: 'Hardtop 2 Dr', description: 'Hardtop 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: '3DHT', displayValue: 'Hardtop 3 Dr', description: 'Hardtop 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: '4DHT', displayValue: 'Hardtop 4 Dr', description: 'Hardtop 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: '5DHT', displayValue: 'Hardtop 5 Dr', description: 'Hardtop 5 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'HB', displayValue: 'Hatchback', description: 'Hatchback', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: '2DHB', displayValue: 'Hatchback 2 Dr', description: 'Hatchback 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, value: '3DHB', displayValue: 'Hatchback 3 Dr', description: 'Hatchback 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, value: '4DHB', displayValue: 'Hatchback 4 Dr', description: 'Hatchback 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('18', { id: 18, value: '5DHB', displayValue: 'Hatchback 5 Dr', description: 'Hatchback 5 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('19', { id: 19, value: 'HR', displayValue: 'Hearse', description: 'Hearse', sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'JP', displayValue: 'Jeep', description: 'Jeep', sortOrder: 999999, active: true });
        this._dictionary.add('21', { id: 21, value: 'LB', displayValue: 'Liftback', description: 'Liftback', sortOrder: 999999, active: true });
        this._dictionary.add('22', { id: 22, value: '2DLB', displayValue: 'Liftback 2 Dr', description: 'Liftback 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('23', { id: 23, value: '3DLB', displayValue: 'Liftback 3 Dr', description: 'Liftback 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('24', { id: 24, value: '4DLB', displayValue: 'Liftback 4 Dr', description: 'Liftback 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('25', { id: 25, value: '5DLB', displayValue: 'Liftback 5 Dr', description: 'Liftback 5 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('26', { id: 26, value: 'LM', displayValue: 'Limousine', description: 'Limousine', sortOrder: 999999, active: true });
        this._dictionary.add('27', { id: 27, value: 'MHA', displayValue: 'Motor Home A', description: 'Motor Home Class A', sortOrder: 999999, active: true });
        this._dictionary.add('28', { id: 28, value: 'MHB', displayValue: 'Motor Home B', description: 'Motor Home Class B', sortOrder: 999999, active: true });
        this._dictionary.add('29', { id: 29, value: 'MHC', displayValue: 'Motor Home C', description: 'Motor Home Class C', sortOrder: 999999, active: true });
        this._dictionary.add('30', { id: 30, value: 'PU', displayValue: 'Pickup', description: 'Pickup', sortOrder: 999999, active: true });
        this._dictionary.add('31', { id: 31, value: '12PU', displayValue: 'Pickup 1/2 Ton', description: 'Pickup 1/2 Ton', sortOrder: 999999, active: true });
        this._dictionary.add('32', { id: 32, value: '34PU', displayValue: 'Pickup 3/4 Ton', description: 'Pickup 3/4 Ton', sortOrder: 999999, active: true });
        this._dictionary.add('33', { id: 33, value: 'RV', displayValue: 'Recreational Vehicle', description: 'Recreational Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('34', { id: 34, value: 'RVVN', displayValue: 'Recreational Van', description: 'Recreational Van', sortOrder: 999999, active: true });
        this._dictionary.add('35', { id: 35, value: 'RH', displayValue: 'Retractable Hardtop', description: 'Retractable Hardtop', sortOrder: 999999, active: true });
        this._dictionary.add('36', { id: 36, value: '2DRH', displayValue: 'Retractable Hardtop 2 Dr', description: 'Retractable Hardtop 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('37', { id: 37, value: '3DRH', displayValue: 'Retractable Hardtop 3 Dr', description: 'Retractable Hardtop 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('38', { id: 38, value: '4DRH', displayValue: 'Retractable Hardtop 4 Dr', description: 'Retractable Hardtop 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('39', { id: 39, value: '5DRH', displayValue: 'Retractable Hardtop 5 Dr', description: 'Retractable Hardtop 5 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('40', { id: 40, value: 'RD', displayValue: 'Roadster', description: 'Roadster', sortOrder: 999999, active: true });
        this._dictionary.add('41', { id: 41, value: 'SD', displayValue: 'Sedan', description: 'Sedan', sortOrder: 999999, active: true });
        this._dictionary.add('42', { id: 42, value: '2DSD', displayValue: 'Sedan 2 Dr', description: 'Sedan 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('43', { id: 43, value: '3DSD', displayValue: 'Sedan 3 Dr', description: 'Sedan 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('44', { id: 44, value: '4DSD', displayValue: 'Sedan 4 Dr', description: 'Sedan 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('45', { id: 45, value: '5DSD', displayValue: 'Sedan 5 Dr', description: 'Sedan 5 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('46', { id: 46, value: 'Special', displayValue: 'SP', description: 'SP', sortOrder: 999999, active: true });
        this._dictionary.add('47', { id: 47, value: 'SW', displayValue: 'Station Wagon', description: 'Station Wagon.  Station Wagon (SW) includes body style for a Sport Utility Vehicle (SUV)', sortOrder: 999999, active: true });
        this._dictionary.add('48', { id: 48, value: '2DSW', displayValue: 'Station Wagon 2 Dr', description: 'Station Wagon 2 Dr.  Station Wagon (SW) includes body style for a Sport Utility Vehicle (SUV)', sortOrder: 999999, active: true });
        this._dictionary.add('49', { id: 49, value: '3DSW', displayValue: 'Station Wagon 3 Dr', description: 'Station Wagon 3 Dr.  Station Wagon (SW) includes body style for a Sport Utility Vehicle (SUV)', sortOrder: 999999, active: true });
        this._dictionary.add('50', { id: 50, value: '4DSW', displayValue: 'Station Wagon 4 Dr', description: 'Station Wagon 4 Dr.  Station Wagon (SW) includes body style for a Sport Utility Vehicle (SUV)', sortOrder: 999999, active: true });
        this._dictionary.add('51', { id: 51, value: '5DSW', displayValue: 'Station Wagon 5 Dr', description: 'Station Wagon 5 Dr.  Station Wagon (SW) includes body style for a Sport Utility Vehicle (SUV)', sortOrder: 999999, active: true });
        this._dictionary.add('52', { id: 52, value: '12VN', displayValue: 'Van 1/2 Ton', description: 'Van 1/2 Ton', sortOrder: 999999, active: true });
        this._dictionary.add('53', { id: 53, value: '34VN', displayValue: 'Van 3/4 Ton', description: 'Van 3/4 Ton', sortOrder: 999999, active: true });
        this._dictionary.add('54', { id: 54, value: 'LL', displayValue: 'Carryall', description: 'Carryall', sortOrder: 999999, active: true });
        this._dictionary.add('55', { id: 55, value: 'AR', displayValue: 'Armored Truck', description: 'Armored Truck', sortOrder: 999999, active: true });
        this._dictionary.add('56', { id: 56, value: 'AC', displayValue: 'Auto Carrier', description: 'Auto Carrier', sortOrder: 999999, active: true });
        this._dictionary.add('57', { id: 57, value: 'BR', displayValue: 'Beverage Rack', description: 'Beverage Rack', sortOrder: 999999, active: true });
        this._dictionary.add('58', { id: 58, value: 'BS', displayValue: 'Bus', description: 'Bus', sortOrder: 999999, active: true });
        this._dictionary.add('59', { id: 59, value: 'CB', displayValue: 'Cab & Chassis', description: 'Cab & Chassis', sortOrder: 999999, active: true });
        this._dictionary.add('60', { id: 60, value: 'CM', displayValue: 'Concrete Mixer', description: 'Concrete Mixer', sortOrder: 999999, active: true });
        this._dictionary.add('61', { id: 61, value: 'CRA', displayValue: 'Crane', description: 'Crane', sortOrder: 999999, active: true });
        this._dictionary.add('62', { id: 62, value: 'DRTK', displayValue: 'Drilling Truck', description: 'Drilling Truck', sortOrder: 999999, active: true });
        this._dictionary.add('63', { id: 63, value: 'DP', displayValue: 'Dump Truck', description: 'Dump Truck', sortOrder: 999999, active: true });
        this._dictionary.add('64', { id: 64, value: 'FT', displayValue: 'Fire Truck', description: 'Fire Truck', sortOrder: 999999, active: true });
        this._dictionary.add('65', { id: 65, value: 'FB', displayValue: 'Flatbed or Platform', description: 'Flatbed or Platform', sortOrder: 999999, active: true });
        this._dictionary.add('66', { id: 66, value: 'GG', displayValue: 'Garbage or Refuse', description: 'Garbage or Refuse', sortOrder: 999999, active: true });
        this._dictionary.add('67', { id: 67, value: 'GR', displayValue: 'Glass Rack', description: 'Glass Rack', sortOrder: 999999, active: true });
        this._dictionary.add('68', { id: 68, value: 'GN', displayValue: 'Grain', description: 'Grain', sortOrder: 999999, active: true });
        this._dictionary.add('69', { id: 69, value: 'HO', displayValue: 'Hopper', description: 'Hopper', sortOrder: 999999, active: true });
        this._dictionary.add('70', { id: 70, value: 'LW', displayValue: 'Lunch Wagon', description: 'Lunch Wagon', sortOrder: 999999, active: true });
        this._dictionary.add('71', { id: 71, value: 'OS', displayValue: 'Open Seed Truck', description: 'Open Seed Truck', sortOrder: 999999, active: true });
        this._dictionary.add('72', { id: 72, value: 'PN', displayValue: 'Panel', description: 'Panel', sortOrder: 999999, active: true });
        this._dictionary.add('73', { id: 73, value: '1TPU', displayValue: 'Pickup 1 Ton', description: 'Pickup 1 Ton', sortOrder: 999999, active: true });
        this._dictionary.add('74', { id: 74, value: 'RF', displayValue: 'Refrigerated Van', description: 'Refrigerated Van', sortOrder: 999999, active: true });
        this._dictionary.add('75', { id: 75, value: 'RT', displayValue: 'Road Tractor', description: 'Road Tractor', sortOrder: 999999, active: true });
        this._dictionary.add('76', { id: 76, value: 'SCBS', displayValue: 'School Bus', description: 'School Bus', sortOrder: 999999, active: true });
        this._dictionary.add('77', { id: 77, value: 'SR', displayValue: 'Service Body Truck', description: 'Service Body Truck', sortOrder: 999999, active: true });
        this._dictionary.add('78', { id: 78, value: 'SPRT', displayValue: 'Spreader Truck', description: 'Spreader Truck', sortOrder: 999999, active: true });
        this._dictionary.add('79', { id: 79, value: 'ST', displayValue: 'Stake or Rack', description: 'Stake or Rack', sortOrder: 999999, active: true });
        this._dictionary.add('80', { id: 80, value: 'TN', displayValue: 'Tank', description: 'Tank', sortOrder: 999999, active: true });
        this._dictionary.add('82', { id: 82, value: 'TRTK', displayValue: 'Trench Truck', description: 'Trench Truck', sortOrder: 999999, active: true });
        this._dictionary.add('83', { id: 83, value: 'TK', displayValue: 'Truck', description: 'Truck', sortOrder: 999999, active: true });
        this._dictionary.add('84', { id: 84, value: 'TT', displayValue: 'Truck Tractor', description: 'Truck Tractor', sortOrder: 999999, active: true });
        this._dictionary.add('85', { id: 85, value: 'VN', displayValue: 'Van', description: 'Van', sortOrder: 999999, active: true });
        this._dictionary.add('86', { id: 86, value: '1TVN', displayValue: 'Van 1 Ton', description: 'Van 1 Ton', sortOrder: 999999, active: true });
        this._dictionary.add('87', { id: 87, value: 'VT', displayValue: 'Vannette', description: 'Vannette', sortOrder: 999999, active: true });
        this._dictionary.add('88', { id: 88, value: 'WR', displayValue: 'Wrecker', description: 'Wrecker', sortOrder: 999999, active: true });
        this._dictionary.add('89', { id: 89, value: 'WRTK', displayValue: 'Wrencher', description: 'Wrencher', sortOrder: 999999, active: true });
        this._dictionary.add('90', { id: 90, value: 'AQTL', displayValue: 'Aqua Trailer', description: 'Aqua Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('91', { id: 91, value: 'BT', displayValue: 'Boat Trailer', description: 'Boat Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('92', { id: 92, value: 'BX', displayValue: 'Box Trailer', description: 'Box Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('93', { id: 93, value: 'CL', displayValue: 'Cable Reel Trailer', description: 'Cable Reel Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('94', { id: 94, value: 'CN', displayValue: 'Concession Trailer', description: 'Concession Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('95', { id: 95, value: 'DL', displayValue: 'Dolly Trailer', description: 'Dolly Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('96', { id: 96, value: 'DPTL', displayValue: 'Dump Trailer', description: 'Dump Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('97', { id: 97, value: 'FBTL', displayValue: 'Flatbed Trailer', description: 'Flatbed Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('98', { id: 98, value: 'GNTL', displayValue: 'Grain Trailer', description: 'Grain Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('99', { id: 99, value: 'HOTL', displayValue: 'Hopper Trailer', description: 'Hopper Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('100', { id: 100, value: 'HE', displayValue: 'Horse Trailer', description: 'Horse Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('101', { id: 101, value: 'LS', displayValue: 'Livestock Trailer', description: 'Livestock Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('102', { id: 102, value: 'LP', displayValue: 'Logging Trailer', description: 'Logging Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('103', { id: 103, value: 'LBTL', displayValue: 'Lowbed/boy Trailer', description: 'Lowbed/boy Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('104', { id: 104, value: 'LG', displayValue: 'Luggage Trailer', description: 'Luggage Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('105', { id: 105, value: 'MCTL', displayValue: 'Motorcycle Trailer', description: 'Motorcycle Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('106', { id: 106, value: 'PL', displayValue: 'Pole Trailer', description: 'Pole Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('107', { id: 107, value: 'RFTL', displayValue: 'Refrigerated Van Trailer', description: 'Refrigerated Van Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('108', { id: 108, value: 'SE', displayValue: 'Semi Trailer', description: 'Semi Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('109', { id: 109, value: 'SRTL', displayValue: 'Service Trailer', description: 'Service Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('110', { id: 110, value: 'SNTL', displayValue: 'Snowmobile Carrier', description: 'Snowmobile Carrier', sortOrder: 999999, active: true });
        this._dictionary.add('111', { id: 111, value: 'STTL', displayValue: 'Stake Trailer', description: 'Stake Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('112', { id: 112, value: 'TNTL', displayValue: 'Tank Trailer', description: 'Tank Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('113', { id: 113, value: 'TE', displayValue: 'Tent Trailer', description: 'Tent Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('114', { id: 114, value: 'TL', displayValue: 'Trailer', description: 'Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('115', { id: 115, value: 'TV', displayValue: 'Travel Trailer', description: 'Travel Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('116', { id: 116, value: 'UT', displayValue: 'Utility Trailer', description: 'Utility Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('117', { id: 117, value: 'VNTL', displayValue: 'Van Trailer', description: 'Van Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('118', { id: 118, value: 'ATC', displayValue: 'All Terrain Cycle', description: 'All Terrain Cycle', sortOrder: 999999, active: true });
        this._dictionary.add('119', { id: 119, value: 'ATV', displayValue: 'All Terrain Vehicle', description: 'All Terrain Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('120', { id: 120, value: 'GC', displayValue: 'Golf Cart', description: 'Golf Cart', sortOrder: 999999, active: true });
        this._dictionary.add('121', { id: 121, value: 'MCSP', displayValue: 'Motorcycle with Unique Modifications', description: 'Motorcycle with Unique Modifications', sortOrder: 999999, active: true });
        this._dictionary.add('122', { id: 122, value: 'MP', displayValue: 'Moped', description: 'Moped', sortOrder: 999999, active: true });
        this._dictionary.add('123', { id: 123, value: 'MC', displayValue: 'Motorcycle', description: 'Motorcycle', sortOrder: 999999, active: true });
        this._dictionary.add('124', { id: 124, value: 'NEV', displayValue: 'Neighborhood Electric Vehicle', description: 'Neighborhood Electric Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('125', { id: 125, value: 'WCMC', displayValue: 'Wheel Chair/Motorcycle Vehicle', description: 'Wheel Chair/Motorcycle Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('126', { id: 126, value: 'MB', displayValue: 'Modular Building', description: 'Modular Building', sortOrder: 999999, active: true });
        this._dictionary.add('127', { id: 127, value: 'MH', displayValue: 'Mobile Home', description: 'Mobile Home', sortOrder: 999999, active: true });
        this._dictionary.add('128', { id: 128, value: 'OT', displayValue: 'Office Trailer', description: 'Office Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('129', { id: 129, value: 'PT', displayValue: 'Park Model Trailer', description: 'Park Model Trailer', sortOrder: 999999, active: true });
        this._dictionary.add('300', { id: 300, value: 'CO', displayValue: 'Competition', description: 'Competition', sortOrder: 999999, active: true });
        this._dictionary.add('301', { id: 301, value: 'CR', displayValue: 'Cruiser', description: 'Cruiser', sortOrder: 999999, active: true });
        this._dictionary.add('302', { id: 302, value: 'DT', displayValue: 'Dirt Bike', description: 'Dirt Bike', sortOrder: 999999, active: true });
        this._dictionary.add('303', { id: 303, value: 'EN', displayValue: 'Enduro', description: 'Enduro', sortOrder: 999999, active: true });
        this._dictionary.add('304', { id: 304, value: 'MN', displayValue: 'MINI BIKE', description: 'MINI BIKE', sortOrder: 999999, active: true });
        this._dictionary.add('305', { id: 305, value: 'MS', displayValue: 'Scooter', description: 'Scooter', sortOrder: 999999, active: true });
        this._dictionary.add('306', { id: 306, value: 'SP', displayValue: 'Sport', description: 'Sport', sortOrder: 999999, active: true });
        this._dictionary.add('307', { id: 307, value: 'TO', displayValue: 'Touring', description: 'Touring', sortOrder: 999999, active: true });
        this._dictionary.add('308', { id: 308, value: 'TR', displayValue: 'Traditional', description: 'Traditional', sortOrder: 999999, active: true });
        this._dictionary.add('310', { id: 310, value: 'UNK', displayValue: 'UNKNOWN', description: 'UNKNOWN', sortOrder: 999999, active: true });
        this._dictionary.add('311', { id: 311, value: 'ROL', displayValue: 'Roll Off', description: 'Roll Off', sortOrder: 999999, active: true });
        this._dictionary.add('312', { id: 312, value: 'SPE', displayValue: 'Special', description: 'Special', sortOrder: 999999, active: true });
        this._dictionary.add('313', { id: 313, value: 'TRN', displayValue: 'Transfer', description: 'Transfer', sortOrder: 999999, active: true });
        this._dictionary.add('314', { id: 314, value: 'CUR', displayValue: 'Curtainside', description: 'Curtainside', sortOrder: 999999, active: true });
        this._dictionary.add('315', { id: 315, value: '6DSW', displayValue: 'Station Wagon 6 Dr', description: 'Station Wagon 6 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('316', { id: 316, value: '2DCP', displayValue: 'Coupe 2 Dr', description: 'Coupe 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('318', { id: 318, value: '3DCP', displayValue: 'Coupe 3 Dr', description: 'Coupe 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('319', { id: 319, value: '4DCP', displayValue: 'Coupe 4 Dr', description: 'Coupe 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('320', { id: 320, value: '2CB', displayValue: 'Cab & Chassis 2 Dr', description: 'Cab & Chassis 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('321', { id: 321, value: '3CB', displayValue: 'Cab & Chassis 3 Dr', description: 'Cab & Chassis 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('322', { id: 322, value: '4CB', displayValue: 'Cab & Chassis 4 Dr', description: 'Cab & Chassis 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('323', { id: 323, value: 'YY', displayValue: 'Cutaway', description: 'Cutaway', sortOrder: 999999, active: true });
        this._dictionary.add('324', { id: 324, value: '2YY', displayValue: 'Cutaway 2 Dr', description: 'Cutaway 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('325', { id: 325, value: '3YY', displayValue: 'Cutaway 3 Dr', description: 'Cutaway 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('326', { id: 326, value: 'GL', displayValue: 'Gliders', description: 'Gliders', sortOrder: 999999, active: true });
        this._dictionary.add('327', { id: 327, value: 'IC', displayValue: 'Incomplete (Strip Chassis)', description: 'Incomplete (Strip Chassis)', sortOrder: 999999, active: true });
        this._dictionary.add('328', { id: 328, value: '2IC', displayValue: 'Incomplete (Strip Chassis) 2 Dr', description: 'Incomplete (Strip Chassis) 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('329', { id: 329, value: '3IC', displayValue: 'Incomplete (Strip Chassis) 3 Dr', description: 'Incomplete (Strip Chassis) 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('330', { id: 330, value: 'IP', displayValue: 'Incomplete Pickup', description: 'Incomplete Pickup', sortOrder: 999999, active: true });
        this._dictionary.add('331', { id: 331, value: '2IP', displayValue: 'Incomplete Pickup 2 Dr', description: 'Incomplete Pickup 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('332', { id: 332, value: '3IP', displayValue: 'Incomplete Pickup 3Dr', description: 'Incomplete Pickup 3Dr', sortOrder: 999999, active: true });
        this._dictionary.add('333', { id: 333, value: '4IP', displayValue: 'Incomplete Pickup 4Dr', description: 'Incomplete Pickup 4Dr', sortOrder: 999999, active: true });
        this._dictionary.add('335', { id: 335, value: '2PU', displayValue: 'Pickup 2Dr', description: 'Pickup 2Dr', sortOrder: 999999, active: true });
        this._dictionary.add('336', { id: 336, value: '3PU', displayValue: 'Pickup 3 Dr', description: 'Pickup 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('337', { id: 337, value: '4PU', displayValue: 'Pickup 4 Dr', description: 'Pickup 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('350', { id: 350, value: '2DPV', displayValue: 'Passenger Van 2 Dr', description: 'Passenger Van 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('351', { id: 351, value: '3DPV', displayValue: 'Passenger Van 3 Dr', description: 'Passenger Van 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('352', { id: 352, value: '4DPV', displayValue: 'Passenger Van 4 Dr', description: 'Passenger Van 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('353', { id: 353, value: '5DPV', displayValue: 'Passenger Van 5 Dr', description: 'Passenger Van 5 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('354', { id: 354, value: 'CG', displayValue: 'Cargo Van', description: 'Cargo Van', sortOrder: 999999, active: true });
        this._dictionary.add('355', { id: 355, value: '2DCG', displayValue: 'Cargo Van 2 Dr', description: 'Cargo Van 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('356', { id: 356, value: '3DCG', displayValue: 'Cargo Van 3 Dr', description: 'Cargo Van 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('357', { id: 357, value: '4DCG', displayValue: 'Cargo Van 4 Dr', description: 'Cargo Van 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('358', { id: 358, value: '5DCG', displayValue: 'Cargo Van 5 Dr', description: 'Cargo Van 5 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('360', { id: 360, value: '3DMHB', displayValue: 'Motor Home B 3 Dr', description: 'Motor Home Class B 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('361', { id: 361, value: 'STT', displayValue: 'Straight Truck', description: 'Straight Truck (Cargo Body and Tractor are mounted to the same chassis)', sortOrder: 999999, active: true });
        this._dictionary.add('362', { id: 362, value: '2DSTT', displayValue: 'Straight Truck 2 Dr', description: 'Straight Truck 2 Dr (Cargo Body and Tractor are mounted to the same chassis)', sortOrder: 999999, active: true });
        this._dictionary.add('363', { id: 363, value: '4DSTT', displayValue: 'Straight Truck 4 Dr', description: 'Straight Truck 4 Dr (Cargo Body and Tractor are mounted to the same chassis)', sortOrder: 999999, active: true });
        this._dictionary.add('364', { id: 364, value: 'SV', displayValue: 'Step Van', description: 'Step Van', sortOrder: 999999, active: true });
        this._dictionary.add('365', { id: 365, value: '2DSV', displayValue: 'Step Van 2 Dr', description: 'Step Van 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('366', { id: 366, value: '3DSV', displayValue: 'Step Van 3 Dr', description: 'Step Van 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('380', { id: 380, value: '2DMHB', displayValue: 'Motor Home B 2 Dr', description: 'Motor Home Class B 2 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('382', { id: 382, value: '3DVC', displayValue: 'Camper Van 3 Dr', description: 'Camper Van 3 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('390', { id: 390, value: 'PV', displayValue: 'Passenger Van', description: 'Passenger Van', sortOrder: 999999, active: true });
        this._dictionary.add('391', { id: 391, value: 'VC', displayValue: 'Camper Van', description: 'Camper Van', sortOrder: 999999, active: true });
        this._dictionary.add('392', { id: 392, value: '4DLM', displayValue: 'Limousine 4 Dr', description: 'Limousine 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('393', { id: 393, value: '4DHR', displayValue: 'Hearse 4 Dr', description: 'Hearse 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('394', { id: 394, value: '4CC', displayValue: 'Commercial Chassis 4 Dr', description: 'Commercial Chassis 4 Dr', sortOrder: 999999, active: true });
        this._dictionary.add('395', { id: 395, value: 'CCH', displayValue: 'Contain Chassis', description: 'Contain Chassis', sortOrder: 999999, active: true });
        this._dictionary.add('396', { id: 396, value: 'NES', displayValue: 'Neighborhood Electric Shuttle', description: 'Neighborhood Electric Shuttle', sortOrder: 999999, active: true });
        this._dictionary.add('397', { id: 397, value: 'MQ', displayValue: 'Motorized Quadricycle', description: 'Motorized Quadricycle', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IBodyStyleType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IBodyStyleType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IBodyStyleType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IBodyStyleType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IBodyStyleType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
